import { SvgIcon } from "@material-ui/core";
import React from "react";
export const TiktokIcon = ({ type }) => (React.createElement(SvgIcon, { viewBox: "0 0 2858.41 3333.23" },
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
            React.createElement("path", { style: {
                    fill: type == "pos" ? "#212121" : "#fff",
                    fillRule: "evenodd",
                }, d: "M2080.41,0c55,473,319,755,778,785v532c-266,26-499-61-770-225v995c0,1264-1378,1659-1932,753-356-583-138-1606,1004-1647v561c-87,14-180,36-265,65-254,86-398,247-358,531,77,544,1075,705,992-358V1h551Z" })))));
export default TiktokIcon;
//# sourceMappingURL=Tiktok.js.map